import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { budgetApi, ApiGroupBudgetSummary } from "../services/api";

export const useGroupBudgets = (refreshTrigger?: number) => {
  const { user } = useAuth();
  const [budgetSummary, setBudgetSummary] = useState<ApiGroupBudgetSummary | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refreshBudgets = useCallback(async () => {
    if (!user?.group_id) {
      setBudgetSummary(null);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const data = await budgetApi.getGroupBudgets(user.group_id);
      setBudgetSummary(data);
    } catch (err: any) {
      setError(err.message || "Failed to load budgets");
      setBudgetSummary(null);
    } finally {
      setLoading(false);
    }
  }, [user?.group_id]);

  useEffect(() => {
    refreshBudgets();
  }, [refreshBudgets, refreshTrigger]);

  return { budgetSummary, loading, error, refreshBudgets };
};
